export default __webpack_public_path__ + "static/sui-a349a95157921f7a2377c026ff380ab7.png";